import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewOption } from '@brafton/angular-framework-library';

@Component({
  selector: 'shared-view-options-panel',
  templateUrl: './view-options-panel.component.html',
  styleUrls: ['./view-options-panel.component.scss'],
  host: { class: 'view-options-panel' },
})
export class SharedViewOptionsPanelComponent {
  @Input() selectedOptions: ViewOption[] = [];
  @Input() viewOptions: ViewOption[] = [];
  @Output() selectedOptionsChange: EventEmitter<ViewOption[]> = new EventEmitter<ViewOption[]>();
  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor() { }

  switchProduct(viewOption: ViewOption) {
    // remove any existing view option that is already selected from the same type
    const index = this.selectedOptions.findIndex((sp) => sp.type === viewOption.type);
    if (index > -1) {
      this.selectedOptions.splice(index, 1);
    }
    // add the whole matched new viewoption to the list of selected options
    this.selectedOptions.push(viewOption);

    this.selectedOptionsChange.emit(this.selectedOptions);
  }

  removeProduct(viewOption: ViewOption) {
    const index = this.selectedOptions.findIndex((sp) => sp.value === viewOption.value);
    if (index > -1) {
      this.selectedOptions.splice(index, 1);
    }
    this.selectedOptionsChange.emit(this.selectedOptions);
  }

  clear() {
    this.selectedOptions = [];
    this.selectedOptionsChange.emit(this.selectedOptions);
  }

  isSelected(viewOption: ViewOption): boolean {
    if (!this.selectedOptions) return false;
    if (this.selectedOptions.find((sp) => sp.value === viewOption.value)) return true;
    else return false;
  }
}
